import { scheduleDueMileage, scheduleDueOn, type Asset, type MaintenanceItem } from '@app/shared';
import { useRecords } from '../../platform/data/repo.ts';
import { daysUntil } from '../../platform/time.ts';

export const KIND_LABELS: Record<Asset['kind'], string> = {
  home: 'Home',
  appliance: 'Appliances',
  vehicle: 'Vehicles',
  system: 'Heating, cooling & plumbing',
  yard: 'Yard & outdoor',
  electronics: 'Electronics',
  other: 'Other',
};

export const KIND_EMOJI: Record<Asset['kind'], string> = {
  home: '🏠',
  appliance: '🧺',
  vehicle: '🚗',
  system: '🔥',
  yard: '🌳',
  electronics: '📺',
  other: '🔧',
};

export function useAssets(): Asset[] | undefined {
  return useRecords<Asset>('assets')?.sort((a, b) => a.name.localeCompare(b.name));
}

export function useMaintenanceItems(): MaintenanceItem[] | undefined {
  return useRecords<MaintenanceItem>('maintenance_items');
}

export interface DueInfo {
  dueOn: string | null;
  dueMileage: number | null;
  days: number | null;
  milesLeft: number | null;
  urgent: boolean;
  overdue: boolean;
}

/** When a schedule is due, by date and/or mileage. */
export function dueInfo(item: MaintenanceItem, asset: Asset | undefined): DueInfo {
  const dueOn = scheduleDueOn(item);
  const dueMileage = scheduleDueMileage(item);
  const days = dueOn ? daysUntil(dueOn) : null;
  const milesLeft = dueMileage !== null && asset?.mileage != null ? dueMileage - asset.mileage : null;
  const overdue = (days !== null && days < 0) || (milesLeft !== null && milesLeft < 0);
  const urgent = overdue || (days !== null && days <= 14) || (milesLeft !== null && milesLeft <= 500);
  return { dueOn, dueMileage, days, milesLeft, urgent, overdue };
}
